import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Calendar, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="py-20 bg-primary relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5">
        <img 
          src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80" 
          alt="" 
          className="w-full h-full object-cover"
        />
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-xl shadow-2xl overflow-hidden">
            <div className="grid md:grid-cols-2">
              <div className="p-10">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                >
                  <h2 className="text-3xl font-monomakh text-primary mb-6">Sei Pronto a Vendere il Tuo Immobile?</h2>
                  <p className="text-gray-600 mb-8">
                    Affida a noi la vendita del tuo immobile e scopri 
                    la differenza di un servizio davvero personalizzato.
                  </p>
                  
                  <div className="space-y-6">
                    <div className="flex items-start">
                      <div className="bg-primary/10 p-3 rounded-full mr-4">
                        <Calendar className="h-6 w-6 text-primary" />
                      </div>
                      <div>
                        <h3 className="font-semibold text-primary mb-1">Consulenza gratuita</h3>
                        <p className="text-gray-600 text-sm">
                          Fissiamo un appuntamento per conoscere il tuo immobile e le tue esigenze.
                        </p>
                      </div>
                    </div>
                    
                    <div className="flex items-start">
                      <div className="bg-primary/10 p-3 rounded-full mr-4">
                        <Phone className="h-6 w-6 text-primary" />
                      </div>
                      <div>
                        <h3 className="font-semibold text-primary mb-1">Chiamaci subito</h3>
                        <p className="text-gray-600 text-sm">
                          +39 327 8855115<br />
                          055 752139
                        </p>
                      </div>
                    </div>
                  </div>
                  
                  <div className="mt-8 space-x-4">
                    <a 
                      href="#valutazione" 
                      className="inline-block bg-primary hover:bg-primary-light text-white font-semibold px-6 py-3 rounded-lg transition-colors"
                    >
                      Richiedi valutazione gratuita
                    </a>
                    <Link 
                      to="/contatti" 
                      className="inline-flex items-center text-primary hover:text-primary-dark font-medium"
                    >
                      Contattaci
                      <ArrowRight className="ml-1 h-4 w-4" />
                    </Link>
                  </div>
                </motion.div>
              </div>
              
              <div className="hidden md:block">
                <img 
                  src="https://images.unsplash.com/photo-1582407947304-fd86f028f716?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
                  alt="Consulente immobiliare" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;